import React, { useEffect, useState } from 'react';
import styles from 'routes/vendorRe/pages/VendorStats.module.css';
import LineChart from 'routes/vendorRe/components/LineChart';
import FlexChild from 'routes/vendorRe/containers/commons/FlexChild';
import HorizontalFlex from 'routes/vendorRe/containers/commons/HorizontalFlex';
import P from 'routes/vendorRe/containers/commons/P';
import VerticalFlex from 'routes/vendorRe/containers/commons/VerticalFlex';
import { requester } from 'App';

const StoreSettlementStatus = (props) => {
    const { storeId } = props;

    const [isMounted, setMounted] = useState(false);
    const [totalWeekEachAmount, setTotalWeekEachAmount] = useState();
    const [salesOverview, setSalesOverview] = useState();

    useEffect(() => {
        setMounted(true);
    }, [])
    useEffect(() => {
        if (isMounted) {
            let storeData = { id: storeId };
            requester.getStoreWeeklySalesStatus(storeData, (result) => {
                
                setTotalWeekEachAmount(result.data);
            })
            requester.getVendorStoreSalesOverview(storeData, (result) => {
                
                setSalesOverview(result.data);
            })
        }
    }, [isMounted])

    return (
        <FlexChild backgroundColor="white" padding="1em" borderRadius="1em">
            <VerticalFlex>
                <FlexChild alignItems={"flex-start"} padding={"0 0 1em"}>
                    <P weight={700} size={"max(1.3vw, 25px)"}>매출현황</P>
                </FlexChild>
                <FlexChild>
                    {/* 라인 그래프 영역 */}
                    <LineChart totalWeekEachAmount={totalWeekEachAmount} />
                </FlexChild>
                <FlexChild>
                    <div className={styles.borderBottom}>
                        <HorizontalFlex padding={"1em 0"}>
                            <FlexChild>
                                <P size={"max(1vw, 20px)"}>오늘 매출</P>
                            </FlexChild>
                            <FlexChild justifyContent={"flex-end"}>
                                <P weight={700} size={"max(1.3vw, 25px)"}>{salesOverview ? salesOverview.todayTotalPrice.toLocaleString() : 0}</P>
                            </FlexChild>
                        </HorizontalFlex>
                    </div>
                    <div className={styles.borderBottom}>
                        <HorizontalFlex padding={"1em 0"}>
                            <FlexChild>
                                <P size={"max(1vw, 20px)"}>이번주 매출</P>
                            </FlexChild>
                            <FlexChild justifyContent={"flex-end"}>
                                <P weight={700} size={"max(1.3vw, 25px)"}>{salesOverview ? salesOverview.thisWeekTotalPrice.toLocaleString() : 0}</P>
                            </FlexChild>
                        </HorizontalFlex>
                    </div>
                    <div className={styles.borderBottom}>
                        <HorizontalFlex padding={"1em 0"}>
                            <FlexChild>
                                <P size={"max(1vw, 20px)"}>이번달 매출</P>
                            </FlexChild>
                            <FlexChild justifyContent={"flex-end"}>
                                <P weight={700} size={"max(1.3vw, 25px)"}>{salesOverview ? salesOverview.thisMonthTotalPrice.toLocaleString() : 0}</P>
                            </FlexChild>
                        </HorizontalFlex>
                    </div>
                    <HorizontalFlex padding={"1em 0"}>
                        <FlexChild>
                            <P size={"max(1vw, 20px)"}>올해 매출</P>
                        </FlexChild>
                        <FlexChild justifyContent={"flex-end"}>
                            <P weight={700} size={"max(1.3vw, 25px)"}>{salesOverview ? salesOverview.thisYearTotalPrice.toLocaleString() : 0}</P>
                        </FlexChild>
                    </HorizontalFlex>
                </FlexChild>
            </VerticalFlex>
        </FlexChild>
    );
};

export default StoreSettlementStatus;